import {
  COST_FILTER_OPTIONS_FAILURE,
  UPDATE_ACCOUNTS_COLORS,
  UPDATE_SERVICES_COLORS,
} from "../components/dashboard/actionTypes/CostChartActionTypes";
import { COST_FILTER_OPTIONS_REQUEST } from "../components/dashboard/actionTypes/CostChartActionTypes";
import {
  DELETE_CHART_DATA,
  UPDATE_CHART_DATA_FAILURE,
  UPDATE_CHART_DATA_REQUEST,
  UPDATE_CHART_DATA_SUCCESS,
  UPDATE_COLORS,
  UPDATE_COST_FILTER_OPTIONS,
} from "../components/dashboard/actionTypes/CostChartActionTypes";

const initialState = {
  masterChartData: {},
  accounts: {},
  regions: {},
  services: [],
  isFetching: false,
  errorMessage: null,
  colors: {
    accounts: {},
    regions: {},
    services: {},
  },
};

export default function costChartReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CHART_DATA_REQUEST:
      return {
        ...state,
        masterChartData: {
          ...state.masterChartData,
          [action.payload.chartId]: {
            ...state.masterChartData[action.payload.chartId],
            isFetching: true,
          },
        },
      };
    case UPDATE_CHART_DATA_SUCCESS:
      return {
        ...state,
        masterChartData: {
          ...state.masterChartData,
          [action.payload.chartId]: {
            ...state.masterChartData[action.payload.chartId],
            [action.payload.queryParam]: action.payload.data,
            isFetching: false,
          },
        },
      };
    case UPDATE_CHART_DATA_FAILURE:
      return {
        ...state,
        masterChartData: {
          ...state.masterChartData,
          [action.payload.chartId]: {
            ...state.masterChartData[action.payload.chartId],
            isFetching: false,
            errorMessage: action.payload.errorMessage,
          },
        },
      };
    case DELETE_CHART_DATA:
      return {
        ...state,
        masterChartData: {},
      };
    case COST_FILTER_OPTIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case UPDATE_COST_FILTER_OPTIONS:
      return {
        ...state,
        accounts: action.payload.accounts,
        regions: action.payload.regions,
        services: action.payload.services,
        isFetching: false,
      };
    case COST_FILTER_OPTIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.errorMessage,
      };
    case UPDATE_COLORS:
      return {
        ...state,
        colors: {
          accounts: action.payload.accounts,
          regions: action.payload.regions,
          services: action.payload.services,
        },
      };
    case UPDATE_ACCOUNTS_COLORS:
      return {
        ...state,
        colors: {
          ...state.colors,
          accounts: action.payload,
        },
      };
    case UPDATE_SERVICES_COLORS: {
      return {
        ...state,
        colors: {
          ...state.colors,
          services: action.payload,
        },
      };
    }
    default:
      return state;
  }
}
